import { useReducer, useEffect, useMemo } from 'react';
import { layoutReducer, loadLayout, saveLayout } from '../lib/dock-layout';

/**
 * Persistent dock layout for the map workspace (localStorage `ultimate-gis:layout:v1`,
 * see lib/dock-layout.js). Returns the layout and bound actions. Stored state that is
 * invalid resets to the default layout instead of throwing.
 */
export function useDockLayout(storage) {
  const [layout, dispatch] = useReducer(layoutReducer, storage, (s) => loadLayout(s));

  useEffect(() => { saveLayout(layout, storage); }, [layout, storage]);

  const actions = useMemo(() => ({
    moveTo: (id, dock) => dispatch({ type: 'moveTo', id, dock }),
    float: (id, rect) => dispatch({ type: 'float', id, rect }),
    reorder: (id, index) => dispatch({ type: 'reorder', id, index }),
    setSize: (dock, size) => dispatch({ type: 'setSize', dock, size }),
    setCollapsed: (dock, value) => dispatch({ type: 'setCollapsed', dock, value }),
    toggleCollapsed: (dock) => dispatch({ type: 'toggleCollapsed', dock }),
    setActive: (dock, id) => dispatch({ type: 'setActive', dock, id }),
    setFloatRect: (id, rect) => dispatch({ type: 'setFloatRect', id, rect }),
    reveal: (id) => dispatch({ type: 'reveal', id }),
    reset: () => dispatch({ type: 'reset' }),
  }), []);

  return { layout, ...actions };
}
